import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

export const ToggleButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

export const RowWrapper = styled.span`
  color: ${({ inactiveAla, ala }) => (inactiveAla[ala] ? '#C50019' : '')};
`;
